<script>
// import VuePerfectScrollbar from 'vue-perfect-scrollbar'

import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import html2pdf from 'html2pdf.js'
import Widget from './widget'

// import axios from 'axios'

export default {
  page: {
    title: '360MDR Reports',
    meta: [{ name: 'description', content: appConfig.description }]
  },
  components: {
    Layout,
    Widget
  },
  props: {
    name: {
      type: String,
      default: 'main.json'
    }
  },
  data () {
    return {
      finishedWidgetsCount: 0,
      widgetsStatus: [],
      showGenerating: true,
      startDateTime: null,
      endDateTime: null,
      startDateTimeShow: null,
      endDateTimeShow: null,
      error: null,
      title: 'Report MDR',
      spacer: '',
      startEpoch: 0,
      endEpoch: 0,
      date: null,
      dateTimePicker: {
        enableTime: true,
        dateFormat: 'm/d/Y H:i'
      },
      dashboard: {
        'widgets': [
          {
            'source': '/pan/xdr/count/timerange/other?collection=cortex_incidents&tvariable=incident.incident.creation_time&variable=incident.incident',
            'id': 'info2',
            'name': 'incidentes totales en el rango de tiempo',
            'cols': 'col-md-6',
            'height_class': 'small',
            'component': 'vindicator',
            'refresh': 60000,
            'range': true,
            'trend': false
          },
          {
            // "source": "/pan/xdr/add/timerange/other?&collection=cortex_incidents&tvariable=incident.incident.creation_time&variable=incident.incident.alert_count",
            			'source': '/pan/xdr/alerts/top?collection=cortex_incidents&variables=incident.alerts.data.category&outvars=reference&tvariable=incident.alerts.data.detection_timestamp&uw=incident.alerts.data&limit=1000&tkind=timestamp&datacount=yes',
            'id': 'info4',
            'name': 'Alertas totales en el rango de tiempo',
            'cols': 'col-md-6',
            'height_class': 'small',
            'component': 'vindicator',
            'refresh': 60000,
            'range': true,
            'trend': false
          },
          // {
          // 	"source": "/pan/xdr/count/timerange/other?collection=cortex_incidents&tvariable=incident.incident.creation_time&variable=incident.incident&match=incident.incident.severity,high",
          // 	"id": "info2",
          // 	"name": "incidentes de severidad en el rango de tiempo",
          // 	"cols": "col-md-4",
          // 	"class": "severity_high",
          // 	"height_class": "small",
          // 	"component": "vindicator",
          // 	"refresh": 60000,
          // 	"range": true,
          // 	"trend": false
          // },
          {
            'source': '/pan/xdr/agg/date/auto?collection=cortex_incidents&variable=incident.incident.creation_time&match=incident.incident.severity,high',
            'id': 'widget2',
            'name': 'CANTIDAD DE INCIDENTES DE SEVERIDAD ALTA',
            'cols': 'col-md-6',
            'height_class': 'tall_widget',
            'component': 'dbar',
            'type': 'bar',
            'colors': ['#DC001E'],
            'range': true,
            'refresh': 60000
          },
          {
            'source': '/pan/xdr/agg/date/auto?collection=cortex_incidents&variable=incident.incident.creation_time',
            'id': 'widget2',
            'name': 'CANTIDAD TOTAL DE INCIDENTES',
            'cols': 'col-md-6',
            'height_class': 'tall_widget',
            'component': 'dbar',
            'type': 'bar',
            'colors': ['#0084FF'],
            'range': true,
            'refresh': 60000
          },
          {
            'source': '/pan/xdr/agg/general?collection=cortex_incidents&variables=incident.incident.severity&outvars=label&tvariable=incident.incident.creation_time&limit=3',
            'source1': '/pan/xdr/agg/general?collection=cortex_incidents&variables=incident.incident.severity&outvars=label&tvariable=incident.incident.modification_time&limit=3',
            'id': 'widget2',
            'name': 'INCIDENTES POR SEVERIDAD',
            'cols': 'col-md-6',
            'height_class': 'tall_widget',
            'component': 'dpie',
            'type': 'donut',
            'colorsByLabel': {
              'high': '#DC001E',
              'medium': '#FECA00',
              'low': '#01AD00'
            },
            'range': true,
            'refresh': 60000
          },
          {
            'source': '/pan/xdr/agg/general?collection=cortex_incidents&variables=incident.incident.status&outvars=label&tvariable=incident.incident.creation_time&limit=6',
            'source1': '/pan/xdr/agg/general?collection=cortex_incidents&variables=incident.incident.status&outvars=label&tvariable=incident.incident.modification_time&limit=6',
            'id': 'widget2',
            'name': 'ACCIONES / EVENTOS',
            'cols': 'col-md-6',
            'height_class': 'tall_widget',
            'component': 'dpie',
            'type': 'donut',
            'colors': ['#0084FF', '#1ab7ea', '#0084ff', '#39539E', '#0077B5'],
            'range': true,
            'refresh': 60000
          },
          {
            'source': '/pan/xdr/alerts/top?collection=cortex_incidents&variables=incident.alerts.data.category&outvars=reference&tvariable=incident.alerts.data.detection_timestamp&uw=incident.alerts.data&limit=10&tkind=timestamp',
            'name': 'TIPOS DE ALERTAS',
            'cols': 'col-md-6',
            'height_class': 'short_widget',
            'component': 'multicolumn',
            'range': true,
            'refresh': 60000
          },
          {
            'source': '/pan/xdr/alerts/top?collection=cortex_incidents&variables=incident.alerts.data.source&outvars=reference&tvariable=incident.alerts.data.detection_timestamp&uw=incident.alerts.data&limit=10&tkind=timestamp',
            'id': 'widget2',
            'name': 'FUENTES DE ALERTAS',
            'cols': 'col-md-6',
            'height_class': 'short_widget',
            'component': 'multicolumn',
            'range': true,
            'refresh': 60000
          },
          {
            'source': '/pan/xdr/alerts/hip/top?variable=incident.alerts.data.host_ip',
            'name': 'TOP DE HOSTS EN ALERTAS',
            'cols': 'col-md-4',
            'height_class': 'short_widget',
            'component': 'multicolumn',
            'range': true,
            'refresh': 60000
          },
          {
            'source': '/pan/xdr/alerts/hip/top?variable=incident.alerts.data.name&maxlength=100',
            'name': 'TOP DE ALERTAS',
            'cols': 'col-md-8',
            'height_class': 'short_widget',
            'component': 'multicolumn',
            'range': true,
            'refresh': 60000
          },
          {
            'source': '/pan/xdr/incidents/starred?include=incident.incident,by360&limit=100',
            'name': 'INCIDENTES DESTACADOS',
            'cols': 'col-md-12',
            'height_class': 'short_widget',
            'component': 'multicolumn',
            'range': true,
            'refresh': 60000,
            'error': 'No hay incidentes destacados en el rango de tiempo.',
            'cardStyle': 'overflow:auto'
          },
          {
            'source': '/recommendations/list?withid=yes',
            'name': 'RECOMENDACIONES',
            'cols': 'col-md-12',
            'height_class': 'short_widget',
            'component': 'recommendations',
            'card_style': 'height: 100% !important;',
            'range': true,
            'refresh': 60000,
            'error': 'No hay recomendaciones en el rango de tiempo.',
            'cardStyle': 'overflow:auto'
          }
        ]
      },
      appConfig: process.env.NODE_ENV === 'production' ? require('@src/app.config') : require('@src/app.config.dev'),
      base: 0,
      pdfConfig: {
        margin: 0.2,
        filename: 'Reporte MDR.pdf',
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: { scale: 2, dpi: 96, letterRendering: true, width: 1280 },
        jsPDF: { unit: 'in', format: 'letter', orientation: 'landscape' },
        pagebreak: { mode: 'css', before: '#page2el' },
        _pageBreak: { mode: 'avoid-all', before: '.break-page', after: '.break-page' }
      }
    }
  },
  computed: {
    dateTimeFormatedRange: function () {
      let res = ''
      if (this.startDateTimeShow !== null) res += this.startDateTimeShow + ' - '
      if (this.endDateTimeShow !== null) res += this.endDateTimeShow
      return res
    }
  },
  mounted () {
    this.showModal()
  },
  methods: {
    showModal () {
      this.$refs['modal-datetime'].show()
    },
    handleOk (evt) {
      let that = this
      if (that.startDateTime === null) {
        that.error = 'Please select a start date and time'
        evt.preventDefault()
      } else if (that.endDateTime === null) {
        that.error = 'Please select an end date and time'
        evt.preventDefault()
      } else {
        that.startEpoch = parseInt(new Date(that.startDateTime).getTime() / 1000)
        that.endEpoch = parseInt(new Date(that.endDateTime).getTime() / 1000)
        console.log(that.startEpoch, that.endEpoch, that.endEpoch - that.startEpoch)
        that.base += 100
        that.spacer = ' -  '
        that.error = null
        that.startDateTimeShow = that.startDateTime
        that.endDateTimeShow = that.endDateTime
        that.finishedWidgetsCount = 0
        that.widgetsStatus = []
      }
    },
    widgetFinished (id, ok, aux) {
      this.finishedWidgetsCount += 1
      this.widgetsStatus.push({ id: id, ok: ok, aux: aux })
    },
    downloadPdf () {
      const element = document.getElementById('pdfcontent')
      html2pdf(element, this.pdfConfig)
    	}
  }
}
</script>

<template>
  <Layout>
    <div
      class="container"
      style="max-width: 1420px !important;"
    >
      <br>
      <!-- {{ finishedWidgetsCount }} - {{ dashboard.widgets.length }} -->
      <br>
      <!-- {{ widgetsStatus }} -->
      <div class="row">
        <div
          class="col-md-12"
          style="text-align:center;"
        >
          <template v-if="finishedWidgetsCount === dashboard.widgets.length">
            <b-button
              class="btn btn-primary btn-sm mr-1"
              variant="light"
              @click="downloadPdf"
            >
              Download PDF
            </b-button>
          </template>
          <template v-else>
            <span>
              Generating...
            </span>
          </template>
        </div>
      </div>
      <div
        id="pdfcontent"
        style="width:1280px;background-color: rgb(237, 239, 243); break-after: page; clear: both;padding-left:20px;padding-right:20px;"
      >
        <section slot="pdf-content">
          <br><br><br>
          <div class="row">
            <div
              class="col-md-12 align-items-center"
              style="text-align:center"
            >
              <h2 style="align:center;cursor:pointer;">
                {{ title }}
              </h2>
              <h4
                style="align:center;cursor:pointer;"
                @click="showModal"
              >
                {{ dateTimeFormatedRange || 'últimas 24 horas' }}
              </h4>
            </div>
          </div>
          <br>
          <div class="row">
            <template v-for="(widget, index) in dashboard.widgets">
              <Widget
                :id="widget.id"
                :key="index + base"
                :title="widget.name"
                :component="widget.component"
                :source="widget.source"
                :cols="widget.cols"
                :trend="widget.trend"
                :wclass="widget.class"
                :type="widget.type"
                :colors="widget.colors"
                :colors-by-label="widget.colorsByLabel"
                :range="widget.range"
                :card-style="widget.cardStyle"
                :start="startEpoch"
                :end="endEpoch"
                :error="widget.error"
                @finished="widgetFinished"
              />
            </template>
          </div>
        </section>
      </div>
    </div>
    <b-modal
      id="incident.incident_id"
      ref="modal-datetime"
      size="xs"
      title="Select Time Range"
      :ok-only="true"
      :centered="true"
      :no-fade="true"
      @ok="handleOk"
    >
      <div class="row">
        <div class="col-md-6">
          <div class="form-group mb-3">
            <label>Start</label>
            <flat-pickr
              v-model="startDateTime"
              :config="dateTimePicker"
              class="form-control"
              placeholder="Date and Time"
            />
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group mb-3">
            <label>End</label>
            <flat-pickr
              v-model="endDateTime"
              :config="dateTimePicker"
              class="form-control"
              placeholder="Date and Time"
            />
          </div>
        </div>
      </div>
      <div
        v-if="error !== null"
        class="row"
      >
        <div
          class="col-md-12 severity_high"
          style="text-align:center"
        >
          {{ error }}
        </div>
      </div>
    </b-modal>
  </Layout>
</template>
